import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ArrowUpRight } from 'lucide-react';
// === PROCESSO SELETIVO (temporário) — ver COMO-REMOVER-O-PS.md ===
import { psConfig } from '../../data/processoSeletivoData';
// === FIM PROCESSO SELETIVO ===

const navItems = [
  { label: 'Início', href: '#home', id: 'home' },
  { label: 'Sobre', href: '#about', id: 'about' },
  { label: 'Galeria', href: '#gallery', id: 'gallery' },
  { label: 'Cases', href: '#cases', id: 'cases' },
  { label: 'Gestão', href: '#management', id: 'management' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20);

      // Scroll-spy: highlight the section currently under the header
      const probeY = 120;
      let current = 'home';
      navItems.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= probeY) current = item.id;
        }
      });
      setActiveSection(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  return (
    <header
      className={
        'fixed top-0 inset-x-0 z-50 bg-night-900/[0.97] border-b border-white/[0.07] transition-all duration-500 ' +
        (isScrolled ? 'shadow-[0_18px_40px_-20px_rgba(0,0,0,0.8)]' : '')
      }
    >
      <div className={'w-full px-5 sm:px-8 lg:px-12 flex items-center justify-between gap-6 transition-all duration-500 ' + (isScrolled ? 'py-3' : 'py-4 md:py-5')}>
        {/* Logo — protagonist of the bar */}
        <a href="#home" className="flex items-center gap-3 group shrink-0" aria-label="AgroTech Inteli">
          <img
            src="/logo-light.png"
            alt="AgroTech Inteli"
            className={'w-auto object-contain transition-all duration-500 group-hover:scale-[1.03] ' + (isScrolled ? 'h-10 md:h-11' : 'h-11 md:h-14')}
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={
                'nav-link text-sm font-medium tracking-wide transition-colors duration-200 ' +
                (activeSection === item.id ? 'is-active text-mist-50' : 'text-mist-300 hover:text-mist-50')
              }
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center shrink-0">
          {/* === PROCESSO SELETIVO — com psConfig.ativo = false, volta a ser "Seja Parceiro" === */}
          {psConfig.ativo ? (
            <Link
              to="/inscricao"
              className="inline-flex items-center gap-2 bg-primary-400 hover:bg-primary-300 text-night-950 text-sm font-semibold py-2.5 px-5 rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(74,222,128,0.6)]"
            >
              Inscreva-se
              <ArrowUpRight size={15} />
            </Link>
          ) : (
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-primary-400 hover:bg-primary-300 text-night-950 text-sm font-semibold py-2.5 px-5 rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(74,222,128,0.6)]"
            >
              Seja Parceiro
              <ArrowUpRight size={15} />
            </a>
          )}
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2.5 rounded-full border bg-white/[0.06] border-white/10 text-mist-50 transition-colors duration-300"
          aria-label="Abrir menu"
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-[65px] z-40 bg-night-950/[0.98] backdrop-blur-sm">
          <div className="container-custom pt-8">
            <ul className="space-y-1">
              {navItems.map((item, i) => (
                <li key={item.href} className="border-b border-white/[0.07]">
                  <a
                    href={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="flex items-center justify-between py-5 text-2xl font-display font-semibold text-mist-50 hover:text-primary-400 transition-colors"
                  >
                    <span>
                      <span className="text-xs font-sans text-primary-400 mr-3 align-middle">0{i + 1}</span>
                      {item.label}
                    </span>
                  </a>
                </li>
              ))}
              <li>
                {/* === PROCESSO SELETIVO — com psConfig.ativo = false, volta a ser "Seja Parceiro" === */}
                {psConfig.ativo ? (
                  <Link
                    to="/inscricao"
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="mt-6 inline-flex items-center gap-2 bg-primary-400 text-night-950 font-semibold py-3.5 px-7 rounded-full"
                  >
                    Inscreva-se
                    <ArrowUpRight size={17} />
                  </Link>
                ) : (
                  <a
                    href="#contact"
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="mt-6 inline-flex items-center gap-2 bg-primary-400 text-night-950 font-semibold py-3.5 px-7 rounded-full"
                  >
                    Seja Parceiro
                    <ArrowUpRight size={17} />
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
